import CarlineGridGroup from './CarlineGridGroup'
import carlineGridContainer from './carlineGridGroupContainer'

export default carlineGridContainer(CarlineGridGroup)
